/**
 * 路径映射接口，用于定义特殊路径的面包屑显示规则
 */
export interface PathMapping {
    title: string;
    href?: string;
}

/**
 * 默认路径映射配置
 * 用于配置特殊路由的面包屑显示规则
 * 注意：路径中可以使用[param]作为参数占位符
 */
export const defaultPathMappings: Record<string, PathMapping> = {
    '/control-panel/companies/add': {
        title: '新增企业',
        href: '/control-panel/companies',
    },
    '/control-panel/companies/edit?id=[param]': {
        title: '编辑企业',
        href: '/control-panel/companies',
    },
    '/users/change-password': { title: '修改密码' },
    '/users/profile': { title: '个人资料' },
    '/users/approvals': { title: '审批' },
    '/users/edit-profile': {
        title: '个人资料',
        href: '/users/profile',
    },
    '/users/edit-profile?user-id=[param]': {
        title: '编辑个人资料',
        href: '/users/edit-profile',
    },
    '/control-panel/users/add': {
        title: '新增用户',
        href: '/control-panel/users',
    },
    '/control-panel/users/edit?id=[param]': {
        title: '编辑用户',
        href: '/control-panel/users',
    },
    '/control-panel/users/view?id=[param]': {
        title: '查看用户',
        href: '/control-panel/users',
    },
    '/control-panel/users/set-perm?id=[param]': {
        title: '设置权限',
        href: '/control-panel/users',
    },
    '/control-panel/users/set-desen-exempts': {
        title: '用户脱敏豁免设置',
        href: '/control-panel/users/set-perm?id=[param]',
    },
    '/control-panel/departments/add': {
        title: '新增部门',
        href: '/control-panel/departments',
    },
    '/control-panel/departments/edit?id=[param]': {
        title: '编辑部门',
        href: '/control-panel/departments',
    },
    '/control-panel/departments/set-manager?id=[param]': {
        title: '部门管理员',
        href: '/control-panel/departments',
    },
    '/control-panel/departments/set-manager-perm?id=[param]&user-id=[param]': {
        title: '设置部门管理员权限',
        href: '/control-panel/departments/set-manager?id=[param]',
    },
    '/control-panel/roles/permission-control-panel/[param]': {
        title: '设置权限',
        href: '/control-panel/roles',
    },
    '/control-panel/roles/add': {
        title: '新增角色',
        href: '/control-panel/roles',
    },
    '/control-panel/roles/edit?id=[param]': {
        title: '编辑角色',
        href: '/control-panel/roles',
    },
    '/control-panel/roles/list-permissions?id=[param]': {
        title: '设置权限',
        href: '/control-panel/roles',
    },
    '/control-panel/desen-rules/add': {
        title: '新增字段脱敏规则',
        href: '/control-panel/desen-rules',
    },
    '/control-panel/desen-rules/edit?id=[param]': {
        title: '编辑字段脱敏规则',
        href: '/control-panel/desen-rules',
    },
    '/control-panel/color-families/add': {
        title: '新增色系',
        href: '/control-panel/color-families',
    },
    '/control-panel/color-families/edit?id=[param]': {
        title: '编辑色系',
        href: '/control-panel/color-families',
    },
    '/control-panel/color-families/set-colors?id=[param]': {
        title: '设置公共颜色',
        href: '/control-panel/color-families',
    },
    '/control-panel/color-families/add-colors?id=[param]': {
        title: '新增公共颜色',
        href: '/control-panel/color-families/set-colors?id=[param]',
    },
    '/control-panel/color-families/edit-colors?id=[param]&color-id=[param]': {
        title: '编辑公共颜色',
        href: '/control-panel/color-families/set-colors?id=[param]',
    },
    '/control-panel/storage-locations': {
        title: '存储地管理',
        href: '/control-panel/storage-locations',
    },
    '/control-panel/product-types/edit?id=[param]': {
        title: '编辑产品类型',
        href: '/control-panel/product-types',
    },
    '/control-panel/product-types/add': {
        title: '新增产品类型',
        href: '/control-panel/product-types',
    },
    '/control-panel/product-types/set-body-parts?id=[param]': {
        title: '设置成衣部位尺码',
        href: '/control-panel/product-types',
    },
    '/control-panel//product-types/set-attribute?id=[param]': {
        title: '设置属性',
        href: '/control-panel//product-types',
    },
    '/control-panel//product-types/set-sizes?id=[param]': {
        title: '设置可用尺码',
        href: '/control-panel//product-types',
    },
    '/control-panel/product-attributes/add': {
        title: '新增预设属性',
        href: '/control-panel//product-attributes',
    },
    '/control-panel//product-attributes/edit?id=[param]': {
        title: '编辑预设属性',
        href: '/control-panel//product-attributes',
    },
    '/control-panel/body-parts/add': {
        title: '新增成衣部位',
        href: '/control-panel/body-parts',
    },
    '/control-panel/body-parts/edit?id=[param]': {
        title: '编辑成衣部位',
        href: '/control-panel/body-parts',
    },
    '/control-panel/part-types/add': {
        title: '新增部件类型',
        href: '/control-panel/part-types',
    },
    '/control-panel/part-types/edit?id=[param]': {
        title: '编辑部件类型',
        href: '/control-panel/part-types',
    },
    '/control-panel/product-categories/add': {
        title: '新增产品分类',
        href: '/control-panel/product-categories',
    },
    '/control-panel/product-categories/edit?id=[param]': {
        title: '编辑产品分类',
        href: '/control-panel/product-categories',
    },
    '/control-panel/product-brands/add': {
        title: '新增产品品牌',
        href: '/control-panel/product-brands',
    },
    '/control-panel/product-brands/edit?id=[param]': {
        title: '编辑产品品牌',
        href: '/control-panel/product-brands',
    },
    '/control-panel/product-sizes/add': {
        title: '新增产品尺码',
        href: '/control-panel/product-sizes',
    },
    '/control-panel/product-sizes/edit?id=[param]': {
        title: '编辑产品尺码',
        href: '/control-panel/product-sizes',
    },
    '/control-panel/garment-regions/add': {
        title: '新增尺码地区',
        href: '/control-panel/garment-regions',
    },
    '/control-panel/garment-regions/edit?id=[param]': {
        title: '编辑尺码地区',
        href: '/control-panel/garment-regions',
    },
    '/control-panel/garment-regions/edit-regions': {
        title: '编辑地区尺码',
        href: '/control-panel/garment-regions',
    },
    '/control-panel/garment-regions/edit-colors': {
        title: '编辑地区颜色',
        href: '/control-panel/garment-regions',
    },
    '/control-panel/material-types/add': {
        title: '新增物料分类',
        href: '/control-panel/material-types',
    },
    '/control-panel/material-types/edit?id=[param]': {
        title: '编辑物料分类',
        href: '/control-panel/material-types',
    },
    '/control-panel/material-types/set-parameters?id=[param]': {
        title: '设置参数',
        href: '/control-panel/material-types',
    },
    '/control-panel//suppliers/add': {
        title: '新增供应商',
        href: '/control-panel//suppliers',
    },
    '/control-panel/suppliers/edit?id=[param]': {
        title: '编辑供应商',
        href: '/control-panel//suppliers',
    },
    '/materials/add': {
        title: '新增物料',
        href: '/materials',
    },
    '/materials/show?id=[param]': {
        title: '物料详情',
        href: '/materials',
    },
    '/materials/edit?id=[param]': {
        title: '设置基本属性',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-style-presets?id=[param]': {
        title: '设置样式值',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-quant-presets?id=[param]': {
        title: '设置量值',
        href: '/materials/show?id=[param]',
    },
    '/materials/add-items?id=[param]': {
        title: '新增清单',
        href: '/materials/show?id=[param]',
    },
    '/materials/apply-items?id=[param]&reuse-id=[param]': {
        title: '套用清单',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-suppliers?id=[param]': {
        title: '设置供应商',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-tech-spec?id=[param]': {
        title: '设置技术规格参数',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-material-suppliers?id=[param]': {
        title: '设置物料的供应商',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-pack-specs?id=[param]': {
        title: '设置物料的包装规格',
        href: '/materials/show?id=[param]',
    },
    '/materials/set-material-tech-spec?id=[param]': {
        title: '设置物料的技术规格参数',
        href: '/materials/show?id=[param]',
    },
    '/materials/show-item?id=[param]&item-id=[param]': {
        title: '清单详情',
        href: '/materials/show?id=[param]',
    },

    '/material-purchase-orders/add?id=[param]': {
        title: '创建采购单',
        href: '/materials',
    },

    '/material-purchase-orders/edit-items?id=[param]&supplierId=[param]': {
        title: '设置采购清单',
        href: '/material-purchase-orders/detail?id=[param]',
    },

    '/material-purchase-orders/detail?id=[param]':{
        title: '采购单详情',
        href: '/material-purchase-orders/list',
    },

    '/material-purchase-orders/edit?id=[param]&materialId=[param]':{
        title: '编辑采购单',
        href: '/material-purchase-orders/detail?id=[param]',
    },

    '/products/add': {
        title: '新增产品',
        href: '/products',
    },
    '/products/edit?id=[param]': {
        title: '修改基本信息',
        href: '/products/show?id=[param]',
    },
    '/products/show?id=[param]': {
        title: '产品详情',
        href: '/products',
    },
    '/products/set-sizes-presets?id=[param]': {
        title: '产品尺码管理',
        href: '/products/show?id=[param]',
    },
    '/products/set-colors?id=[param]': {
        title: '产品颜色管理',
        href: '/products/show?id=[param]',
    },
    '/products/sku-manage?id=[param]': {
        title: 'SKU管理',
        href: '/products/show?id=[param]',
    },
    '/products/versions?id=[param]': {
        title: '版本',
        href: '/products/show?id=[param]',
    },
    '/products/version-sku-manage?id=[param]&version-id=[param]': {
        title: 'SKU配置',
        href: '/products/versions?id=[param]',
    },
    '/products/version-set-attribute?id=[param]&version-id=[param]': {
        title: '属性管理',
        href: '/products/versions?id=[param]',
    },
    '/products/designers?id=[param]': {
        title: '工艺人员',
        href: '/products/show?id=[param]',
    },
    '/products/product-tags': {
        title: '产品标签',
        href: '/products',
    },
    '/products/product-tags/show?tag=[param]': {
        title: '产品列表',
        href: '/products',
    },
    '/products/selected-products': {
        title: '选中产品项',
        href: '/products',
    },
    '/products/product-configs/fabric?id=[param]': {
        title: '配置面料',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/fabric/available?id=[param]&compId=[param]': {
        title: '设置可用面料',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/fabric/parts?id=[param]&compId=[param]': {
        title: '设置部件',
        href: '/products/product-configs/fabric?id=[param]',
    },
    '/products/product-configs/fabric/part-areas?id=[param]&compId=[param]&partId=[param]':
        {
            title: '设置部件面积',
            href: '/products/product-configs/fabric/parts?id=[param]&compId=[param]',
        },
    '/products/product-configs/fabric/colors?id=[param]': {
        title: '绑定颜色',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/material?id=[param]': {
        title: '配置物料',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/material/available?id=[param]&materialTypeId=[param]&configId=[param]':
        {
            title: '设置可用物料',
            href: '/products/show?id=[param]',
        },
    '/products/product-configs/material/rules?id=[param]&configId=[param]': {
        title: '配置物料规则',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/material/items?id=[param]&configId=[param]': {
        title: '配置物料清单',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/padding?id=[param]': {
        title: '配置填充物',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/padding/available?id=[param]&configId=[param]': {
        title: '设置可用填充物',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/padding/parts?id=[param]&configId=[param]': {
        title: '设置部件',
        href: '/products/show?id=[param]',
    },
    '/products/product-configs/padding/part-areas?id=[param]&configId=[param]&partId=[param]':
        {
            title: '设置部件面积',
            href: '/products/product-configs/padding/parts?id=[param]&configId=[param]',
        },

    '/products/garment-labels/hang-tags?id=[param]': {
        title: '配置吊牌',
        href: '/products/show?id=[param]',
    },
    '/products/garment-labels/care-labels?id=[param]': {
        title: '配置水洗标',
        href: '/products/show?id=[param]',
    },
};
